import React, { Component } from 'react'

import styles from './styles.module.scss'

interface IProps {
  color?: string
}

export class EllipsisLoader extends Component<IProps> {
  render() {
    let { color } = this.props

    return (
      <div className={styles.spinner}>
        <div style={{ backgroundColor: color }} className={styles.bounce1} />
        <div style={{ backgroundColor: color }} className={styles.bounce2} />
        <div style={{ backgroundColor: color }} />
      </div>
    )
  }
}
